// extracted by mini-css-extract-plugin
export default {"avatar":"avatar---ehsSw","placeholder":"placeholder---wIP9w"};